import React, { Fragment } from 'react';
import './BreadCrumb.scss';
import { NavLink, useLocation } from 'react-router-dom';
import CaretDown from '../icons/CaretDown';
import { matchingtitleFromPath } from '../../services/constantes';
import { useNavLinksQuery } from '../../services/api';

const getPathes = (pathname, navLinks) => {
  const links = Object.values(navLinks).flat();
  const [first, second = first] = pathname.split('/').filter(Boolean);
  if (['bulletin', 'omi'].includes(first)) {
    return [
      'Bulletins',
      matchingtitleFromPath[second] ??
        links.find(item => item.code === second)?.name ??
        second,
    ];
  }
  if (['map-view', 'range'].includes(first)) {
    return ['Views', matchingtitleFromPath[second]];
  }
  if (['tz-view', 'in-situ'].includes(first)) {
    return ['Expert views', matchingtitleFromPath[second]];
  }
  return [];
};

const BreadCrumb = ({ className }) => {
  const { data: navLinks = {} } = useNavLinksQuery();
  const { pathname } = useLocation();
  const pathes = getPathes(pathname, navLinks);
  if (!pathes.length) {
    return null;
  }
  return (
    <nav className={`breadcrumb ${className ?? ''}`} aria-label="breadcrumb">
      <ol>
        <li>
          <NavLink to="/">Home</NavLink>
        </li>
        {pathes.map(path => (
          <Fragment key={path}>
            <li role="presentation" aria-hidden>
              <CaretDown />
            </li>
            <li>{path}</li>
          </Fragment>
        ))}
      </ol>
    </nav>
  );
};

export default BreadCrumb;
